var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTraderIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2561 12.3333C18.2561 12.8343 18.0611 13.3147 17.714 13.669C17.3668 14.0232 16.896 14.2222 16.4051 14.2222H5.29878L1.59668 18V2.88889C1.59668 2.38792 1.7917 1.90748 2.13884 1.55324C2.48598 1.19901 2.9568 1 3.44773 1H16.4051C16.896 1 17.3668 1.19901 17.714 1.55324C18.0611 1.90748 18.2561 2.38792 18.2561 2.88889V12.3333Z",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTraderIco);
export default __webpack_public_path__ + "static/media/myTraderIco.955796d85c21d4aa73d0d14c4be9c508.svg";
export { ForwardRef as ReactComponent };